import type { CmpHider } from './types';

export const piwikPro: CmpHider = {
  id: 'piwik-pro',
  label: 'Piwik PRO Consent Manager',
  css: `
      /* Piwik PRO Consent Manager (ppms.cm, "Powered by Piwik PRO"): the consent
         form is injected into a single root container "div[id^=ppms_cm_consent_popup]"
         that holds a fixed overlay "#ppms_cm_popup_overlay" (.ppms_cm_popup_overlay,
         position:fixed, z-index 10000) wrapping the banner card "#ppms_cm_popup"
         (.ppms_cm_popup). In the default bottom-bar config the overlay is a fixed bar
         (Agree/Disagree buttons #ppms_cm_agree-to-all / #ppms_cm_disagree), and when
         the visitor opens preferences it expands into a full-viewport modal with a
         dimming backdrop on that same overlay plus a settings screen
         (.ppms_cm_consent_screen). Hiding the overlay removes the popup, the modal, and
         the dimmer in one go; we also hide the root popup container, .ppms_cm_popup,
         and .ppms_cm_consent_screen defensively in case a build mounts them outside the
         overlay. A second config renders a slim persistent bar instead of the popup:
         a "div[id^=ppms_cm_consent_bar]" root holding a fixed "#ppms_cm_bar_overlay"
         (.ppms_cm_consent_bar) with an "open settings" link (.ppms_cm_open-popup_link)
         that reopens the popup — hide the bar root and overlay too. The "ppms_cm"
         prefix is specific to the Consent Manager UI, so this does not touch unrelated
         "wp-block-piwikpro-*" page content or the analytics "ppms" global. Piwik PRO
         does not lock page scroll via a body class or inline style on the sites
         observed; if a build does, the html/html-body [style*="overflow"] and
         [style*="position: fixed"] release rules above already out-specify an inline
         overflow/position lock. */
      [id^="ppms_cm_consent_popup"],
      [id^="ppms_cm_consent_bar"],
      #ppms_cm_popup_overlay,
      .ppms_cm_popup_overlay,
      #ppms_cm_popup,
      .ppms_cm_popup,
      #ppms_cm_bar_overlay,
      .ppms_cm_consent_bar,
      .ppms_cm_consent_screen { display: none !important; }
  `,
};
